// "From" on a link: who what they send is from. One field for making a link
// and for editing one, on every screen size: the handle typed or a person
// tapped from People (their handle is what is stored, their name is what shows).
import { usePeople } from '@/db/hooks'
import { personFor } from '@/lib/people'
import { Button, Field } from './ui'

export const FromField = ({
  value,
  onChange,
  label = 'From',
  hint = 'What they send is labelled with them, and lands on their page in People. They cannot change it.',
  testId,
}: {
  value: string
  onChange: (handle: string) => void
  label?: string
  hint?: string
  testId?: string
}) => {
  const people = usePeople().filter((p) => !p.deleted_at && !p.spec.me)
  const found = personFor(people, value)
  return (
    <Field label={label} hint={found ? `${found.spec.name}, from People. ${hint}` : hint}>
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full"
        autoCapitalize="off"
        placeholder="A name, e.g. Keira"
        data-testid={testId}
      />
      {people.length > 0 && (
        <span className="flex flex-wrap gap-1.5 mt-2" role="group" aria-label="People">
          {people.slice(0, 8).map((p) => (
            <Button
              key={p.id}
              variant={found?.id === p.id ? 'chipOn' : 'chip'}
              aria-pressed={found?.id === p.id}
              onClick={() => onChange(p.spec.key)}
            >
              {p.spec.name}
            </Button>
          ))}
        </span>
      )}
    </Field>
  )
}
